<!-- GAP-UC-43 — Preferences overlay body. PrimeNG 17 + PrimeFlex + SCSS. Real data (phase 8). -->
<div class="ui-prefs" role="group" aria-labelledby="uiPrefsHeading">
  <h3 id="uiPrefsHeading" class="mt-0 mb-3">Postavke prikaza</h3>

  <div *ngIf="viewState === 'loading'" id="uiPrefsLoading" class="flex align-items-center gap-2"
       aria-live="polite">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i><span>Učitavanje…</span>
  </div>

  <div *ngIf="viewState === 'error'" id="uiPrefsError" class="p-error flex align-items-center gap-2"
       role="alert">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <span>Postavke trenutačno nisu dostupne — primijenjen je zadani izgled.</span>
  </div>

  <ng-container *ngIf="viewState !== 'loading' && viewState !== 'error'">
    <!-- (A) Default left-menu state — REQ-003 -->
    <fieldset class="field mt-2 border-none p-0 m-0">
      <legend id="menuStateLabel" class="font-medium mb-2">Zadano stanje lijevog izbornika</legend>
      <div class="flex gap-3" role="radiogroup" aria-labelledby="menuStateLabel">
        <div class="flex align-items-center gap-2">
          <p-radioButton inputId="menuStateExpanded" name="menuState" value="EXPANDED"
            [(ngModel)]="menuState"></p-radioButton>
          <label for="menuStateExpanded">Otvoren (prošireno)</label>
        </div>
        <div class="flex align-items-center gap-2">
          <p-radioButton inputId="menuStateCollapsed" name="menuState" value="COLLAPSED"
            [(ngModel)]="menuState"></p-radioButton>
          <label for="menuStateCollapsed">Zatvoren (sažeto)</label>
        </div>
      </div>
    </fieldset>

    <!-- (B) Default landing page — REQ-006/007/008 -->
    <div *ngIf="!landingDisabled" class="field mt-3">
      <label for="landingDropdown" id="landingLabel" class="block mb-2">Zadana početna stranica</label>
      <p-dropdown inputId="landingDropdown" [options]="landingOptions" [(ngModel)]="landingName"
        optionLabel="label" optionValue="value" placeholder="Odaberite stranicu"
        ariaLabel="Zadana početna stranica" [showClear]="true" [filter]="true"
        filterPlaceholder="Pretraži stranice" styleClass="w-full"></p-dropdown>
      <small *ngIf="landingOptions.length === 1" id="landingSingleNote" class="block mt-1">
        Dostupna je samo jedna stranica — postavljena kao zadana.
      </small>
      <!-- OQ-CI-2 resolved: stale saved landing falls back to the standard home page. -->
      <small id="landingStaleNote" class="block mt-1 text-500">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Ako spremljena stranica više nije dostupna, otvorit će se početna stranica.
      </small>
    </div>

    <!-- E1 / REQ-010: zero navigable items -->
    <div *ngIf="landingDisabled" id="landingEmptyNote" class="field mt-3 text-500" aria-live="polite">
      Nema dostupnih stranica za odabir — nakon prijave otvara se početna stranica.
    </div>

    <small *ngIf="validationError" id="uiPrefsValidation" class="p-error block mt-2" role="alert">
      {{ validationError }}
    </small>
    <div *ngIf="viewState === 'saved'" id="uiPrefsSaved"
         class="flex align-items-center gap-2 mt-2 text-green-600" aria-live="polite">
      <i class="pi pi-check" aria-hidden="true"></i><span>Spremljeno.</span>
    </div>

    <div class="flex justify-content-end gap-2 mt-4">
      <button id="uiPrefsCancelBtn" pButton type="button" label="Odustani" class="p-button-text"
        (click)="cancel()"></button>
      <button id="uiPrefsSaveBtn" pButton type="button" label="Spremi"
        [loading]="viewState === 'saving'" (click)="save()"></button>
    </div>
  </ng-container>
</div>
